import { IFilterElement } from "@saleor/components/Filter";
import {
  CornermarkFilterKeys,
  CornermarkListFilterOpts
} from "@saleor/cornermarks/components/CornermarkListPage";
import {
  CornermarkListUrlFilters,
  CornermarkListUrlFiltersEnum,
  CornermarkListUrlQueryParams
} from "@saleor/cornermarks/urls";
import { maybe } from "@saleor/misc";
import { CornerMarkFilterInput } from "@saleor/types/globalTypes";
import {
  createFilterTabUtils,
  createFilterUtils,
  getGteLteVariables,
  getMinMaxQueryParam
} from "@saleor/utils/filters";

export const ATTRIBUTE_FILTERS_KEY = "cornermarkFilters";

export function getFilterOpts(
  params: CornermarkListUrlFilters
): CornermarkListFilterOpts {
  return {
    created: {
      active: maybe(
        () =>
          [params.createdFrom, params.createdTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.createdTo, ""),
        min: maybe(() => params.createdFrom, "")
      }
    }
  };
}

export function getFilterVariables(
  params: CornermarkListUrlFilters
): CornerMarkFilterInput {
  return {
    created: getGteLteVariables({
      gte: params.createdFrom,
      lte: params.createdTo
    }),
    search: params.query
  };
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<CornermarkListUrlFilters>(ATTRIBUTE_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  CornermarkListUrlQueryParams,
  CornermarkListUrlFilters
>(CornermarkListUrlFiltersEnum);

export function getFilterQueryParam(
  filter: IFilterElement<CornermarkFilterKeys>
): CornermarkListUrlFilters {
  const { name } = filter;

  switch (name) {
    case CornermarkFilterKeys.created:
      return getMinMaxQueryParam(
        filter,
        CornermarkListUrlFiltersEnum.createdFrom,
        CornermarkListUrlFiltersEnum.createdTo
      );
  }
}
